import styled from 'styled-components/native'
import StyleVariables from "../../../StyleVariables";

export const Paragraph = styled.Text<{
    fontColor: string,
    fontSize: 'normal'|'small'|'large'
}>`
    font-size: ${({ fontSize }) => fontSize === 'normal' ? '14px' : (fontSize === 'small' ? '12px' : '18px') };
    color: ${({ fontColor }) => fontColor ? fontColor : StyleVariables.colorGrey};
`